module.exports = __webpack_public_path__ + "cd455783/img/arrow-left-icon.785c715c.svg";